import createSagaMiddleware from 'redux-saga';
import persistState from 'redux-localstorage';
import filter from 'redux-localstorage-filter';
import { createStore, applyMiddleware, compose } from 'redux';
import localStorageAdapter from 'redux-localstorage/lib/adapters/localStorage';
import { lineItemWatcher } from '../lineItem/lineItemSagas';

import appReducer from './appReducer';

const sagaMiddleware = createSagaMiddleware();

const sagas = [lineItemWatcher];







const middleware = [sagaMiddleware];

const persistedPaths = [
    'lineItems',
    'addresses',
    'shippingGroups'
];

const storage = compose(filter(persistedPaths))(localStorageAdapter(window.localStorage));


const enhancers = compose(
    
    
    applyMiddleware(...middleware),
    
    
    persistState(storage, 'cashstar-mallfront'),
    typeof window === 'object' && typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ !== 'undefined'
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()
        : f => f  
);


export const appStore = createStore(appReducer, undefined, enhancers);



if (typeof window._getSanitizedState !== 'undefined') {
    window._getSanitizedState = () => {
                const state = appStore.getState();         
        return state;
    };
}


sagas.map(sagaMiddleware.run);
